import { render, staticRenderFns } from "./DetailArsip.vue?vue&type=template&id=352a1efc&"
import script from "./DetailArsip.vue?vue&type=script&lang=js&"
export * from "./DetailArsip.vue?vue&type=script&lang=js&"
import style0 from "./DetailArsip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports